import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { Box, Grid, Typography, CircularProgress } from "@mui/material";
import { API_URL } from "../../Config/api";

const InactiveEmp = () => {
  const accessToken = localStorage.getItem("token");
  const [loading, setLoading] = useState(true);
  const [counts, setCounts] = useState({
    black_list_professional: 0,
    active_professionals: 0,
    inactive_professionals: 0,
  });

  useEffect(() => {
    const getDashboardData = async () => {
      try {
        const res = await fetch(
          `${API_URL}/hhc_admin/prof_active_inactive_dashbord_details/`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );
        const data = await res.json();
        setCounts(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching Data:", error);
        setLoading(false);
      }
    };
    getDashboardData();
  }, [accessToken]);

  const series = [
    {
      name: "Professionals",
      data: [
        counts.active_professionals || 0,
        counts.inactive_professionals || 0,
        counts.black_list_professional || 0,
      ],
    },
  ];

  const options = {
    chart: {
      type: "bar",
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        borderRadius: 6,
        columnWidth: "45%", // Bars ko thoda patla rakha hai professional look ke liye
        distributed: true,
        dataLabels: {
          position: "top", // Numbers bar ke upar dikhenge
        },
      },
    },
    colors: ["#10b981", "#f59e0b", "#ef4444"], // Emerald Green, Amber, Red
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val;
      },
      offsetY: -20, // Number ko bar se thoda upar move kiya
      style: {
        fontSize: "12px",
        fontWeight: "bold",
        colors: ["#374151"],
      },
    },
    legend: {
      show: false,
    },
    grid: {
      show: true,
      borderColor: "#f1f1f1",
      strokeDashArray: 4, // Dash lines background mein
      yaxis: {
        lines: { show: true },
      },
      xaxis: {
        lines: { show: false },
      },
    },
    xaxis: {
      categories: ["Active", "Inactive", "Blacklisted"],
      position: "bottom",
      axisBorder: { show: false },
      axisTicks: { show: false },
      labels: {
        style: {
          fontSize: "12px",
          fontWeight: 600,
          colors: "#6b7280",
        },
      },
    },
    yaxis: {
      axisBorder: { show: false },
      axisTicks: { show: false },
      labels: {
        show: true,
        style: {
          colors: "#9ca3af",
        },
      },
    },
    tooltip: {
      theme: "light",
    },
  };

  return (
    <Box
      sx={{ flexGrow: 1, width: "100%", height: "100%" }}
      style={{
        background: "#ffffff",
        boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
        borderRadius: "10px",
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          fontSize: 14,
          fontWeight: 800,
          mb: 2,
          color: "#1f2937",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
        
          pl: 1,
        }}
      >
        Staff Status Overview
      </Typography>

      <Typography variant="caption" sx={{ color: "#4b5563", fontWeight: 700 }}>
        TOTAL SYSTEM STRENGTH:{" "}
        {counts.active_professionals +
          counts.inactive_professionals +
          counts.black_list_professional}
      </Typography>

      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexGrow: 1,
          }}
        >
          <CircularProgress size={25} thickness={5} sx={{ color: "#10b981" }} />
        </Box>
      ) : (
        <>
          <Box sx={{ flexGrow: 1 }}>
            <Chart options={options} series={series} type="bar" height="240" />
          </Box>

          <Box
            sx={{
              mt: 1,
              p: 1,
              bgcolor: "#f9fafb",
              borderRadius: "8px",
              textAlign: "center",
            }}
          ></Box>
        </>
      )}
    </Box>
  );
};

export default InactiveEmp;
